import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from '@core/auth/auth.service';

import { NavMainNode } from '@core/models/nav-main.model';
import { UserProfile } from '@core/models/user-profile.model';

@Component({
  selector: 'fdx-nav-main',
  templateUrl: './nav-main.component.html',
  styleUrls: ['./nav-main.component.scss']
})
export class NavMainComponent {
  @Input() nodes: NavMainNode[];
  @Input() userProfile: UserProfile;

  constructor(private authService: AuthService, private router: Router) {}

  onClickLogout(): void {
    this.authService.logout();
    this.router.navigate(['/login']);
  }

  getPathModule(node: NavMainNode): string[] {
    return [`/${node.path}`];
  }
}
